import type { Recipe } from '../../build-config';
import { isSignature, onPlans } from '../helpers/elevations';
import { styleLayer } from '../helpers/layers';

export const planSignatureRecipe = (plans: string[], state?: Recipe['state']): Recipe => ({
  layers: [styleLayer],
  where: (elevation) => isSignature(elevation) && onPlans(plans)(elevation),
  state
});
